import React from "react";

export const BigGreenCheck = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="129"
    height="128"
    viewBox="0 0 129 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.894531 64C0.894531 28.6538 29.5483 0 64.8945 0C100.241 0 128.895 28.6538 128.895 64C128.895 99.3462 100.241 128 64.8945 128C29.5483 128 0.894531 99.3462 0.894531 64Z"
      fill="#D3FCD2"
    />
    <path
      d="M56.3349 88C55.2262 87.9964 54.1688 87.5329 53.4149 86.72L33.9749 66.04C32.4616 64.4273 32.5422 61.8933 34.1549 60.38C35.7676 58.8667 38.3016 58.9473 39.8149 60.56L56.2949 78.12L89.9349 41.32C90.8651 40.1617 92.3606 39.6143 93.8188 39.8984C95.277 40.1826 96.4576 41.2515 96.8848 42.6744C97.312 44.0972 96.9154 45.6396 95.8549 46.68L59.2949 86.68C58.548 87.5077 57.4896 87.9861 56.3749 88H56.3349Z"
      fill="#22C55E"
    />
  </svg>
);
